import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import branchBar from './lib/branch-bar';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { I18nextProvider } from 'react-i18next';

import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import App from 'components/App';
import Login from 'components/Login';
import ForgotPassword from 'components/ForgotPassword';
import i18n from './i18n';

branchBar.init();

ReactDOM.render(
	<I18nextProvider i18n={i18n}>
		<Router>
			<div className="_">
				<Route path="/:language/t/" component={App} />
				<Route path="/:language/t/password/:resetToken?/" component={ForgotPassword} />
				<Route exact path="/:language/t/login/" component={Login} />
				<Route exact path="/:language/" render={() => <Redirect to={`/${i18n.language}/t/`} />} />
				<Route exact path="/" render={() => <Redirect to={`/${i18n.language}/t/`} />} />
			</div>
		</Router>
	</I18nextProvider>,
	document.getElementById('root')
);
